import React from 'react';
import { useTranslation } from 'react-i18next';
import classes from './SomethingWentWrong.module.scss';

export default function SomethingWentWrong({ message }) {
  const { t } = useTranslation();
  return (
    <div className={classes.wrapper}>
      <h4 className={classes.label} style={{ textAlign: 'center' }}>
        {message || t('profile.validations.SOMETHING_WENT_WRONG')}
      </h4>
    </div>
  );
}
